import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { IDripFeeder } from './types';
import { DripFeeder } from './DripFeeder';

export const DripFeederWrapper = () => {
  const { data: fetchedDripFeeders, mutate: mutateDripFeeders, isLoading, isValidating, error } = useSWR<IDripFeeder[] | undefined>(
    `${SERVICES.USER}/dripFeeder`,
  );
  const [dripFeeders, setDripFeeders] = useState<IDripFeeder[]>([]);

  useEffect(() => {
    if (fetchedDripFeeders) {
      setDripFeeders(fetchedDripFeeders?.slice().sort((a, b) => a?.rank - b?.rank));
    }
  }, [fetchedDripFeeders]);

  return <>
    {dripFeeders &&
      <DripFeeder
        mutateDripFeeders={mutateDripFeeders}
        fetchedDripFeeders={dripFeeders}
        isLoading={(!error && isValidating) || isLoading}
      />
    }
  </>;
};
